import { Decimal } from "decimal.js";

/**
 * 単価
 */
export default class UnitPrice {
  private readonly price: Decimal;

  public constructor(price: Decimal.Value) {
    this.price = new Decimal(price).floor();
  }

  /**
   * numberに変換する
   */
  public toNumber(): number {
    return this.price.toNumber();
  }

  /**
   * 複数個の合計を求める
   */
  public items(items: Decimal.Value): Decimal {
    return this.price.times(items).round();
  }

  /**
   * 損失率から損失を計算する
   */
  public loss(lossRate: Decimal.Value): Decimal {
    return this.price.times(new Decimal(lossRate).div(100));
  }
}
